const mediaItems = [
  {
    id: 1,
    title: '【深度吃瓜】某顶流塌房事件全景复盘',
    duration: '15:42',
    views: '89万',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20video%20thumbnail%20style%20illustration%20of%20a%20dark%20stage%20with%20falling%20spotlight%2C%20dramatic%20red%20curtain%20crashing%20down%2C%20intense%20breaking%20news%20atmosphere%2C%20warm%20dramatic%20lighting%20in%20deep%20red%20and%20amber%20tones%2C%20editorial%20documentary%20style&width=640&height=360&seq=media-video-01&orientation=landscape',
  },
  {
    id: 2,
    title: '【独家解读】直播带货一哥供应链造假内幕全揭秘',
    duration: '22:18',
    views: '67万',
    img: 'https://readdy.ai/api/search-image?query=A%20documentary-style%20investigative%20video%20thumbnail%20of%20supply%20chain%20investigation%20with%20magnifying%20glass%20over%20documents%2C%20warm%20office%20interrogation%20lighting%2C%20suspenseful%20atmosphere%20in%20amber%20and%20warm%20gray%20tones&width=640&height=360&seq=media-video-02&orientation=landscape',
  },
  {
    id: 3,
    title: '【瓜友投稿合集】本月最离谱的十大爆料故事',
    duration: '10:55',
    views: '54万',
    img: 'https://readdy.ai/api/search-image?query=A%20fun%20compilation-style%20video%20thumbnail%20with%20collage%20of%20juicy%20gossip%20stories%2C%20playful%20tabloid%20aesthetic%2C%20warm%20vibrant%20colors%20in%20rose%20and%20golden%20tones%2C%20entertainment%20news%20magazine%20cover%20style&width=640&height=360&seq=media-video-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              精彩视频
            </h2>
            <p className="text-sm text-foreground-500">吃瓜也要有声有色，热门事件视频解读</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {mediaItems.map((item) => (
              <div
                key={item.id}
                className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200 group cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-200">
                      <i className="ri-play-fill text-xl text-primary-500 group-hover:text-white transition-colors ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded">
                    {item.duration}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-800 mb-2 line-clamp-2 leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-400">
                    <i className="ri-eye-line mr-1"></i>{item.views} 次观看
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}